/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-unreachable */
import React from 'react'
import styled from 'styled-components'
import HeaderSuccess from './components/success'
import TicketStore from './components/store_ticket'
import Spei from './components/instructions_spei'
import Container from '../../components/container'
import { useLocation, Redirect, useHistory } from 'react-router-dom'
import Layout from '../../components/layout_user'
import Payed from './components/payed'
import Cover from '../../components/layout_user/cover'
import PictureSrc from '../../../assets/coverPrimary.jpg'
import { Box, Grid, Typography, Divider, useMediaQuery, Button } from '@material-ui/core'
import { NotificationsNoneOutlined } from '@material-ui/icons'
import Item from './components/items'
import currency from '../../../helpers/currency'
import { pay } from '../../../config'
import PaypalSrc from '../../../assets/paypal.png'

const Success = props => {
  const history = useHistory()
  const { methodPay, orderId, subTotal, tax, totalPrice, user, items, doAdressAexist } = props.location.state
  const isMobile = useMediaQuery('(max-width:600px)')
  var { state = {} } = useLocation()

  return (
    <Layout>

      {methodPay === 'paypal' && (
        <>
          <Cover
            picture={PictureSrc}
            title='Estatus de tu pago'
          />
          <Container>
            <PaypalContent>
              <Title>Gracias por tu pago vía</Title>
              <Paypal src={PaypalSrc} />
              <Button variant='contained' size={isMobile ? 'small' : 'large'} color='primary' style={{ width: '250px', margin: 'auto', display: 'block' }} onClick={event => history.push('/tienda')}>
                Cerrar
              </Button>
            </PaypalContent>
          </Container>
        </>
      )}
      {methodPay !== 'paypal' && (
        <>
          <Cover
            picture={PictureSrc}
            title='Resumen de tu pedido'
          />
          <Container>
            <Box pt={{ xs: 1, md: 10, lg: 18 }}>
              <Content>
                <Notice>
                  <Alert>
                    <NotificationsNoneOutlined />
                  </Alert>
                  <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
                    IMPORTANTE
                  </Typography>
                  <Typography>
                    No pierdas tu comprobante de pago. <br />
                    Para poder procesar tu compra es necesario que envíes tu voucher al correo <span>operaciones@laboratoriosiml.com</span> ó mándanos una foto al  <span>WhatsApp (442) 817 3500</span><br /><br />
                    Una vez recibido tu comprobante de pago, nos comunicaremos contigo para programar la cita de tus estudios. Si tu comprobante lo recibimos de 7:00am a 6:00pm te llamaremos en el transcurso de 1 hora. Después de las 6:00pm nos comunicaremos contigo al día siguiente a partir de las 8:00am.
                  </Typography>
                </Notice>

                <Box pt={2} pb={2}>
                  <Grid container justify='space-between'>
                    <Grid item xs>
                      <Typography color='secondary' align='left'>Tu número de orden </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography variant={isMobile ? 'subtitle1' : 'h6'} color='primary' align={isMobile ? 'left' : 'right'}>{orderId}</Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Divider />

                <Box pt={2} pb={2}>
                  <Typography variant='h6' color='primary'>Detalles de pedido</Typography>
                  {items.map(item => (<Item disableDelete key={item.id} {...item} />))}
                </Box>
                <Divider />

                <Box p={2} style={{ background: 'var(--first)', borderRadius: '5px', color: '#fff' }}>
                  <Grid container justify='space-between'>
                    <Grid item xs>
                      <Typography variant={isMobile ? 'subtitle1' : 'h6'} align='left'>Total {methodPay !== 'paypal' ? 'a pagar' : 'pagado'} </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography variant={isMobile ? 'subtitle1' : 'h6'} align={isMobile ? 'left' : 'right'}> $ {currency.formatMoney(totalPrice)}</Typography>
                    </Grid>
                  </Grid>
                </Box>
                {methodPay !== 'paypal' && (
                  <>
                    <Box pt={2}>
                      <Typography variant='h6' color='primary'>Datos de la cuenta</Typography>
                    </Box>

                    <Box pt={2} pb={2}>
                      <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2}>
                        <Grid container justify='space-between' spacing={1}>
                          <Grid item xs={12}><Typography variant='h6' align='center' style={{ marginBottom: '10px' }} color='primary'>Datos de Transferencia Interbancaria</Typography></Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Beneficiario:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>Servicios Clínicos Especializados IML</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Clabe:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>002680701013860051</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Cuenta:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>1386005</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Banco:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>Citibanamex</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>

                    <Box pt={2} pb={2}>
                      <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2}>
                        <Grid item xs={12}><Typography variant='h6' align='center' style={{ marginBottom: '10px' }} color='primary'>Datos de Transferencia en Citibanamex</Typography></Grid>
                        <Grid container justify='space-between' spacing={1}>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Beneficiario:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>Servicios Clínicos Especializados IML</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Cuenta:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>1386005</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Sucursal:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>7010</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>

                    <Box pt={2} pb={2}>
                      <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2}>
                        <Grid container justify='space-between' spacing={1}>
                          <Grid item xs={12}><Typography variant='h6' align='center' style={{ marginBottom: '10px' }} color='primary'>Pagos en Oxxo</Typography></Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Beneficiario:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>Servicios Clínicos Especializados IML</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Cuenta:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>1386005</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Sucursal:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>7010</Typography>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Banco:</Typography>
                          </Grid>
                          <Grid item xs={12} sm={9}>
                            <Typography variant='subtitle1' color='primary' align='left'>Citibanamex</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </>
                )}
                <Box pt={2} pb={2}>
                  <Typography variant='h6' color='primary'>Tus datos</Typography>
                  <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2} mb={2}>
                    <Grid container justify='space-between' spacing={2}>
                      <Grid item xs={12} sm={3}>
                        <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Nombre:</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Typography variant='subtitle1' color='primary' align='left'>{user.name} {user.lastname}</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2} mb={2}>
                    <Grid container justify='space-between' spacing={2}>
                      <Grid item xs={12} sm={3}>
                        <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Email:</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Typography variant='subtitle1' color='primary' align='left'>{user.email}</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2} mb={2}>
                    <Grid container justify='space-between' spacing={2}>
                      <Grid item xs={12} sm={3}>
                        <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Fecha de Nacimiento:</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Typography variant='subtitle1' color='primary' align='left'>{user.date}</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                  {doAdressAexist && (
                    <Box style={{ background: '#f1f1f1', borderRadius: '10px' }} p={2} mb={2}>
                      <Grid container justify='space-between' spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant='subtitle1' color='secondary' align={isMobile ? 'left' : 'right'}>Dirección</Typography>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                          <Typography variant='subtitle1' color='primary' align='left'>{`${user.street_number}, ${user.suburb}, ${user.postal_code}, ${user.city}, ${user.state}`}</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  <Typography style={{ color: 'gray' }}><span>Nota: </span>Se envió esta misma información al correo proporcionado</Typography>
                </Box>

              </Content>
            </Box>
          </Container>
        </>
      )}
    </Layout>
  )

  // if (state.methodPay === 'PayPal' || state.methodPay === 'card' || state.methodPay === 'paypal') {
  //   return (
  //     <Layout>
  //       <HeaderSuccess />
  //       <Container>
  //         <Content>
  //           <Payed />
  //         </Content>
  //       </Container>
  //     </Layout>
  //   )
  // }
  // if (state.methodPay === 'card') return 'cardSuccess'

  // if (state.methodPay === 'cash') {
  //   return (
  //     <Layout>
  //       <HeaderSuccess message='Ahora solo sigue las intrucciones para realizar el pago.' />
  //       <Container>
  //         <Content>
  //           <TicketStore {...state} />
  //         </Content>
  //       </Container>
  //     </Layout>
  //   )
  // }

  // if (state.methodPay === 'spei') {
  //   return (
  //     <Layout>
  //       <HeaderSuccess message='Ahora solo sigue las intrucciones para realizar el pago.' />
  //       <Container>
  //         <Content>
  //           <Spei {...state} />
  //         </Content>
  //       </Container>
  //     </Layout>
  //   )
  // }
  // return (<Redirect to='/error-404' />)
}

const Content = styled.div`
  max-width: 600px;
  margin: auto;
`

const Notice = styled(Box)`
  background: var(--second);
  color: #fff;
  padding: 25px;
  border-radius: 5px;
  position: relative;
  & span {
    font-weight: bold;
  }
`

const Alert = styled.div`
  background: red;
  position: absolute;
  border-radius: 12px;
  border: 3px solid #fff;
  padding: 3px;
  top: -25px;
  left: -25px;
  & svg {
    font-size: 3em;
  }
`
const Paypal = styled.img`
  width: 180px;
  display: block!important;
  margin: 40px auto;
`
const Title = styled.div`
  text-align: center;
  font-size: 3em;
  font-weight: bold;
  color: var(--second);
  @media screen and (max-width:600px){
    font-size: 2em;
  }
`
const PaypalContent = styled.div`
  margin-top: 100px;
  padding: 50px 0px;
  @media screen and (max-width:1767px) {
    margin-top: 20px;
  }
  @media screen and (max-width:1625px) {
    margin-top: 100px;
  }
  @media screen and (max-width:1602px) {
    margin-top: 50px;
  }
  @media screen and (max-width:1380px) {
    margin-top: 100px;
  }
  @media screen and (max-width:991px) {
    margin-top: -10px;
  }
`
export default Success
